/* ============================================================
   BONHEUR - Regla de la placa de chocolate
   BigStudio 2026

   QUE PROBLEMA RESUELVE
   Una torta INDIVIDUAL no lleva placa de chocolate: la placa es una
   pieza para torta entera. Pero el catalogo SI tiene esa combinacion
   creada como variante ("Individual / Con placa", $13.990 en
   torta-amor), asi que sin esta regla el cliente puede pagar por algo
   que la cocina no produce.

   Por decision del cliente el catalogo NO se toca, o sea que no se
   borra esa variante. La regla vive en el tema.

   REPARTO DE TAREAS
   1. snippets/variant-main-picker.liquid ESCONDE la opcion de la
      placa cuando el tamano elegido es individual. Lo hace en el
      servidor, asi que no hay parpadeo y se vuelve a aplicar solo en
      cada re-render del selector.
   2. Este archivo CORRIGE LA SELECCION. Es lo que el Liquid no puede
      hacer: si el cliente venia con "Grande + Con placa" y cambia a
      "Individual", el navegador manda las dos marcas y el servidor
      resolveria "Individual / Con placa", justo la combinacion que
      queremos evitar.
   3. Y APAGA LA DEDICATORIA cuando no hay placa que grabar. La parte
      visual la sostiene assets/bonheur-placa.css; aca se vacia el
      campo y se deja disabled, que es lo que el CSS no puede hacer.

   POR QUE EN FASE DE CAPTURA
   assets/variant-picker.js escucha 'change' en BURBUJA sobre el
   elemento <variant-picker> y de ahi arma option_values leyendo
   "fieldset input:checked". Un escucha en CAPTURA sobre ese mismo
   elemento corre ANTES, alcanza a mover la marca a "Sin placa", y
   Horizon lee el estado ya corregido. No hace falta parchear ni una
   linea del componente del tema.

   SI ESTE ARCHIVO NO CARGA
   No se rompe nada: la opcion de la placa simplemente vuelve a
   aparecer en individual, que es como estaba antes. Ninguna funcion
   del tema depende de el.
   ============================================================ */

(function () {
  'use strict';

  /* --- Configuracion de la regla ---------------------------------
     Se compara SIN tildes y en minusculas, por substring, porque los
     nombres de opcion del catalogo no son uniformes: la opcion de la
     placa se llama "Placa de chocolate con dedicatoria " (con espacio
     al final) en siete productos y "Placa de chocolate" en otro. */
  var TAMANOS_SIN_PLACA = ['individual'];
  var MARCA_OPCION_PLACA = 'placa';
  var MARCA_VALOR_CON_PLACA = 'con placa';

  /* El rango de diacriticos combinantes se arma con fromCharCode y no
     se escribe como literal a proposito: escrito con escapes viaja mal
     por algunos transportes JSON, y escrito con los caracteres de
     verdad es invisible en el editor y cualquier normalizacion Unicode
     lo cambia en silencio. Asi el archivo queda 100% ASCII. */
  var DIACRITICOS = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');

  function normalizar(texto) {
    return String(texto == null ? '' : texto)
      .toLowerCase()
      .normalize('NFD')
      .replace(DIACRITICOS, '')
      .trim();
  }

  function esOpcionDePlaca(campo) {
    var nombre = campo.getAttribute('data-option-name');
    return normalizar(nombre).indexOf(MARCA_OPCION_PLACA) !== -1;
  }

  function contieneAlguno(valor, lista) {
    for (var i = 0; i < lista.length; i++) {
      if (valor.indexOf(lista[i]) !== -1) return true;
    }
    return false;
  }

  /* El tamano elegido prohibe la placa. Se miran TODAS las opciones
     que no son la de la placa, no solo una llamada "Tamano": hay
     tortas donde el individual viaja en una opcion con otro nombre. */
  function prohibeLaPlaca(selector) {
    var marcados = selector.querySelectorAll('fieldset input:checked');
    for (var i = 0; i < marcados.length; i++) {
      if (esOpcionDePlaca(marcados[i])) continue;
      if (contieneAlguno(normalizar(marcados[i].value), TAMANOS_SIN_PLACA)) return true;
    }

    var listas = selector.querySelectorAll('select');
    for (var j = 0; j < listas.length; j++) {
      var elegido = listas[j].options[listas[j].selectedIndex];
      if (!elegido || esOpcionDePlaca(elegido)) continue;
      if (contieneAlguno(normalizar(elegido.value), TAMANOS_SIN_PLACA)) return true;
    }

    return false;
  }

  /* Que placa quedo elegida. Devuelve true si es "Con placa", false si
     es "Sin placa", y null si el producto ni siquiera tiene esa
     opcion, caso en el que este archivo no opina sobre la
     dedicatoria. */
  function eligioConPlaca(selector) {
    var hayOpcion = false;

    var campos = selector.querySelectorAll('fieldset input[type="radio"]');
    for (var i = 0; i < campos.length; i++) {
      if (!esOpcionDePlaca(campos[i])) continue;
      hayOpcion = true;
      if (campos[i].checked) {
        return normalizar(campos[i].value).indexOf(MARCA_VALOR_CON_PLACA) === 0;
      }
    }

    var listas = selector.querySelectorAll('select');
    for (var j = 0; j < listas.length; j++) {
      var elegido = listas[j].options[listas[j].selectedIndex];
      if (!elegido || !esOpcionDePlaca(elegido)) continue;
      hayOpcion = true;
      return normalizar(elegido.value).indexOf(MARCA_VALOR_CON_PLACA) === 0;
    }

    return hayOpcion ? false : null;
  }

  /* Enciende o apaga la opcion de la placa AL INSTANTE, sin esperar
     al servidor.

     snippets/variant-main-picker.liquid ya pone esta misma clase, pero
     recien llega con el repintado de la seccion, que se midio entre
     474 y 654 ms. Ese medio segundo entre el clic y el cambio, con 308
     px que aparecen de golpe al final, es lo que el cliente describio
     como que la ficha "se pegaba".

     Aca se adelanta el resultado y el repintado posterior solo
     confirma lo mismo. La clase la sigue mandando el servidor, asi que
     si este archivo no carga, todo funciona igual, solo que con el
     retardo de antes.

     Esconder por CSS no altera lo que lee Horizon: variant-picker.js
     arma option_values con querySelectorAll, que no mira estilos. */
  function sincronizarOpcionPlaca(selector) {
    var apagar = prohibeLaPlaca(selector);
    var campos = selector.querySelectorAll('fieldset input[type="radio"]');

    for (var i = 0; i < campos.length; i++) {
      if (!esOpcionDePlaca(campos[i])) continue;
      var caja = campos[i].closest('.variant-option');
      if (caja) caja.classList.toggle('variant-option--bh-oculta', apagar);
    }
  }

  function radiosDeLaPlaca(selector) {
    var con = null;
    var sin = null;
    var campos = selector.querySelectorAll('fieldset input[type="radio"]');

    for (var i = 0; i < campos.length; i++) {
      if (!esOpcionDePlaca(campos[i])) continue;
      if (normalizar(campos[i].value).indexOf(MARCA_VALOR_CON_PLACA) === 0) {
        con = campos[i];
      } else {
        sin = campos[i];
      }
    }

    return { con: con, sin: sin };
  }

  /* Devuelve true solo si de verdad hubo que mover algo. */
  function corregir(selector) {
    if (!prohibeLaPlaca(selector)) return false;

    var placa = radiosDeLaPlaca(selector);
    if (!placa.con || !placa.sin || !placa.con.checked) return false;

    placa.con.checked = false;
    placa.sin.checked = true;
    return true;
  }

  /* La dedicatoria se apaga cuando NO hay placa que grabar.

     OJO CON LA REGLA: manda la placa elegida, no el tamano. Antes esto
     miraba prohibeLaPlaca(), o sea el tamano, y por eso en una torta
     grande con "Sin placa" marcado el campo seguia pidiendo la
     dedicatoria. Como en individual la placa se fuerza a "Sin placa",
     ese caso queda cubierto igual.

     La parte visual la sostiene assets/bonheur-placa.css, porque el
     morph del tema repinta este bloque desde el servidor y le borra el
     hidden. Aca se hace lo que el CSS no puede: vaciar el campo y
     dejarlo disabled. Un campo escondido con texto adentro igual viaja
     como propiedad de linea y llegaria al pedido. */
  function sincronizarDedicatoria(selector) {
    var conPlaca = eligioConPlaca(selector);
    if (conPlaca === null) return;

    var ambito = selector.closest('.shopify-section') || document;
    var cajas = ambito.querySelectorAll('.bh-dedic');
    var apagar = !conPlaca;

    for (var i = 0; i < cajas.length; i++) {
      cajas[i].hidden = apagar;
      var campo = cajas[i].querySelector('.bh-dedic__input');
      if (campo && apagar && campo.value) campo.value = '';
      if (campo) campo.disabled = apagar;
    }
  }

  function conectar(selector) {
    if (selector.__bhPlaca) return;
    selector.__bhPlaca = true;

    selector.addEventListener(
      'change',
      function () {
        corregir(selector);
        /* Las dos se sincronizan en el mismo tic: el estado ya esta
           corregido y todavia no llega la respuesta del morph. */
        sincronizarOpcionPlaca(selector);
        sincronizarDedicatoria(selector);
      },
      true
    );

    /* Y OTRA VEZ DESPUES DEL MORPH. El repintado del tema trae el HTML
       del servidor, que llega sin hidden y sin disabled, asi que lo
       aplicado en el tic anterior se pierde. El CSS ya sostiene lo
       visual; esto repone el disabled y el vaciado del campo.

       No entra en bucle: reponer un atributo que ya esta puesto no
       genera una mutacion nueva. */
    var seccion = selector.closest('.shopify-section');
    if (seccion && 'MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        Promise.resolve().then(function () {
          pendiente = false;
          sincronizarOpcionPlaca(selector);
          sincronizarDedicatoria(selector);
        });
      }).observe(seccion, { childList: true, subtree: true });
    }

    sincronizarOpcionPlaca(selector);
    sincronizarDedicatoria(selector);

    /* Carga inicial. Cubre el caso de un enlace viejo con
       ?variant=<Individual / Con placa>: ahi el servidor pinta la
       combinacion prohibida y hay que devolver la pagina a un estado
       valido.

       Mover las marcas NO basta. El precio y el input name="id" del
       formulario no los pinta el selector: los actualizan otros
       componentes del tema que escuchan ProductSelectEvent. Hay que
       avisar con un change de verdad. */
    cuandoTodoEsteListo(function () {
      if (!corregir(selector)) {
        sincronizarDedicatoria(selector);
        return;
      }

      var placa = radiosDeLaPlaca(selector);
      if (placa.sin) placa.sin.dispatchEvent(new Event('change', { bubbles: true }));
      limpiarVariantDeLaUrl();
      sincronizarDedicatoria(selector);
    });
  }

  /* POR QUE window.load Y NO DOMContentLoaded

     Los componentes que pintan el precio y el boton de compra son
     modulos ES y registran su escucha DESPUES que este archivo, que es
     un script clasico con defer. Un aviso disparado antes de que
     terminen de cargar se pierde en el vacio.

     Esto no es teoria: se midio. Con el aviso en DOMContentLoaded las
     marcas se movian a "Sin placa" pero el precio se quedaba en
     $13.990 y el formulario seguia agregando la variante prohibida, o
     sea un estado peor que no hacer nada, porque los botones decian
     una cosa y el carrito recibia otra.

     window.load es el punto donde ya corrieron todos los modulos. */
  function cuandoTodoEsteListo(fn) {
    if (document.readyState === 'complete') {
      fn();
      return;
    }
    window.addEventListener('load', fn, { once: true });
  }

  /* El parametro variant de la URL seguiria apuntando a la combinacion
     prohibida y volveria a aparecer en cada recarga. Al sacarlo, la
     ficha queda en su primera variante, que es la valida. */
  function limpiarVariantDeLaUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* Sin URL limpia igual queda bien: manda el formulario. */
    }
  }

  function arrancar(contexto) {
    var selectores = (contexto || document).querySelectorAll('variant-picker');
    for (var i = 0; i < selectores.length; i++) conectar(selectores[i]);
  }

  /* La escucha se engancha lo antes posible. No importa que Horizon
     registre la suya despues: el orden de la fase de CAPTURA lo decide
     la fase, no quien se registro primero. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      arrancar(document);
    });
  } else {
    arrancar(document);
  }

  /* Compra rapida, recomendados y el editor del tema montan
     selectores nuevos despues de la carga. */
  document.addEventListener('shopify:section:load', function (e) {
    arrancar(e.target);
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var nuevos = cambios[i].addedNodes;
        for (var j = 0; j < nuevos.length; j++) {
          if (nuevos[j].nodeType !== 1) continue;
          if (nuevos[j].matches && nuevos[j].matches('variant-picker')) conectar(nuevos[j]);
          else arrancar(nuevos[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
